module.exports = __webpack_public_path__ + "static/media/resize_icon.9806d0ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/resize_icon.png
// module id = 2252
// module chunks = 0